// Components==============
import InputField from 'components/UI/InputField/InputField';
import React, { useState } from 'react';
import { AutoCorrectionStatus } from '../Test';
import './AutoCorrection.module.scss';
// =========================

const correctString = 'de feits van Jan';

export default function AutoCorrection({
    autoCorrectionStatus,
    setAutoCorrectionStatus,
}: {
    autoCorrectionStatus: AutoCorrectionStatus;
    setAutoCorrectionStatus: React.Dispatch<
        React.SetStateAction<AutoCorrectionStatus>
    >;
}) {
    const [value, setValue] = useState('');

    return (
        <div styleName="wrapper">
            <InputField
                value={value}
                setValue={setValue}
                boxState={autoCorrectionStatus}
                // @ts-ignore
                setBoxState={setAutoCorrectionStatus}
                handleSubmit={(e) => {
                    e?.preventDefault();
                    if (
                        value.toLocaleLowerCase() ===
                        correctString.toLocaleLowerCase()
                    )
                        return setAutoCorrectionStatus('correct');

                    setAutoCorrectionStatus('wrong');
                }}
                readOnly={false}
            />
        </div>
    );
}
